import type { ProfileConfig } from "./types";

export const visaI2ProfileConfig: ProfileConfig = {
    benefits: null,
};
